export default __webpack_public_path__ + "static/media/flag-7.0e08f68a.gif";